<template>
  <div class="el-container">
    <el-main>
      <div v-for="item in solutionList" :id="'nesc_' + item.title" :ref="'nesc_' + item.title" :key="item.id" class="nesc_nd1_li">
        <div class="nesc_cont1360 nesc_about_content clearfix">
          <el-row class="margin-top-sm " style="flex-wrap: wrap" type="flex" :gutter="20" justify="space-around">
            <el-col :span="10" :xs="20" :sm="9">
              <img class="nesc_list_png" :src="require('../assets/image/solutions/' + item.title+'.png')">
            </el-col>
            <el-col :span="10" :xs="24" :sm="12">
              <div class="flex-column-left nesc_txt1830">
                <h3 class="nesc_title40 nesc_nd1_title  animated">{{ $t('lang.' + item.title) }}</h3>
                <p class="nesc_nd1_txt">{{ $t('lang.' + item.content) }}</p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-main>

    <div class="nesc_aside_navbox mc_aside_navbox1" :class="{show: show}" style="">
      <ul class="nesc_aside_nav">
        <li v-for="item in solutionList" :key="item.id" :class="{'on': activeSlide == item.title}" class="nesc_aside_li" @click="scrollToPosition(item.title)">
          {{ $t('lang.' + item.title) }}
        </li>
      </ul>
    </div>

  </div>

</template>

<script>
export default {
  name: 'Solutions',
  data: () => {
    return {
      solutionList: [
        { id: 's1', title: 'heavyTransport', content: 'heavyCarContent' },
        { id: 's2', title: 'logisticsFreight', content: 'huoCheContent' },
        { id: 's3', title: 'cityDelivery', content: 'sanLunContent' },
        { id: 's4', title: 'lightPassengerVehicle', content: 'chenYongContent' },
        { id: 's5', title: 'highSpeedMotorcycle', content: 'elecMoContent' },
        { id: 's6', title: 'electricalTools', content: 'elecContent' },
        { id: 's7', title: 'drone', content: 'wuRenJiContent' }
      ],

      activeSlide: 'heavyTransport',
      topArr: [],
      start: 0,
      parH: 0,
      show: !0,
      navHeight: 0
    }
  },

  watch: {
    '$route': {
      handler: 'scrollToPosition',
      immediate: true
    }
  },

  updated() {
  },
  mounted() {
    this.reset()
    window.addEventListener('scroll', this.handleScroll, true)
    window.addEventListener('resize', () => {
      this.reset()
    }, false)
  },

  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', () => {
      this.reset()
    }, false)
  },

  methods: {
    scrollToPosition(param) {
      if (param.name && param.name == 'solutions') {
        param = param.params.type
      }
      setTimeout(() => {
        for (const i in this.solutionList) {
          if (param == this.solutionList[i].title) {
            window.scrollTo({ top: this.topArr[i], behavior: 'smooth' })
            return
          }
        }
        // window.addEventListener('scroll',this.handleScroll)
      }, 50)
    },

    reset() {
      const topArr = []
      for (const i of this.solutionList) {
        const div = document.getElementById('nesc_' + i.title)
        topArr.push(div.offsetTop)
      }
      this.topArr = topArr

      const navHeight = document.getElementsByClassName('mc_pc_hd')[0].clientHeight
      const start = document.getElementsByClassName('el-container')[0].offsetTop - navHeight
      const list = document.getElementsByClassName('nesc_nd1_li')
      const parH = list[list.length - 1].offsetTop - start
      this.start = start
      this.parH = parH
      this.navHeight = navHeight
    },

    handleScroll() {
      const mcNavbox = document.getElementsByClassName('mc_aside_navbox1')
      let mcNavboxClientHeight = 0
      mcNavbox && mcNavbox.length > 0 && (mcNavboxClientHeight = mcNavbox[0].clientHeight / 2)

      const isTop = document.documentElement.scrollTop > 0
      const isBot = document.documentElement.scrollTop < document.getElementsByClassName('mc_ft')[0].offsetTop - window.innerHeight / 2 - mcNavboxClientHeight
      if (isTop && isBot) {
        this.show = !0
      } else {
        this.show = !1
      }

      for (let i = 0; i < this.topArr.length; i++) {
        if (document.documentElement.scrollTop > this.topArr[i] - window.innerHeight / 3 + this.navHeight) {
          this.activeSlide = this.solutionList[i].title
        } else {
          return
        }
      }
    }

  }
}
</script>

<style scoped lang="scss">
.el-header {
  height: auto !important;
}

.nesc_about_content {
  position: relative;
  z-index: 1;
  overflow: hidden;
  margin: 0 auto;
}

.nesc_list_png {
  width: 100%;
  position: relative;
  z-index: 1;
  top: 0;
  left: 0;
  object-fit: cover;
}

.nesc_nd1_title {
  text-align: left;
  margin-bottom: 48px;
}

.nesc_txt1830 p {
  font-size: 18px;
  line-height: 30px;
  color: #666666;
  font-family: "微软雅黑", Arial, "PingFangSC-Light", "Helvetica Neue", Helvetica, "Microsoft Yahei", "Hiragino Sans GB", tahoma, SimSun, sans-serif;
}

.nesc_nd1_txt {
  margin-bottom: 36px;
}

.nesc_nd1_li {
  padding: 100px 0 85px;
}

.nesc_nd1_li:nth-child(even) {
  background: #f8f8f8;
}

.nesc_nd1_li:nth-child(even) .el-row {
  flex-flow: row-reverse;
}

@media screen and (max-width: 1680px) {
  .nesc_txt1830 p {
    font-size: 16px;
    line-height: 28px;
  }
}

@media screen and (max-width: 1440px) {
  .nesc_nd1_title {
    margin-bottom: 30px;
  }
  .nesc_nd1_txt {
    margin-bottom: 30px;
  }
  .nesc_nd1_li {
    padding: 80px 0 60px;
  }
}

@media screen and (max-width: 991px) {
  .nesc_nd1_txt {
    margin-bottom: 20px;
  }
  .nesc_nd1_li {
    padding: 40px 0;
  }
}

@media screen and (max-width: 767px) {
  .nesc_txt1830 p {
    font-size: 14px;
    line-height: 24px;
  }
  .nesc_nd1_li {
    padding: 20px 0;
  }
}

</style>
